/** `SS:DD` (00:00–23:59). */
export const TIME_OF_DAY_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/

export const isTimeOfDay = (value: string | undefined): value is string =>
  value !== undefined && TIME_OF_DAY_PATTERN.test(value)
